import { getNestedTranslation } from '@colonist/i18n';
import { PlayerColor } from '@colonist/game-states';
import { EnumUtils } from '@colonist/utils';
import { AudioManager, AudioType } from '@colonist/audio';
import { editProfileIdMap } from '@colonist/clientforge';
import { UIImagePathController } from '../../UIEnums.ts';
import { navigateToPage } from '../../ui_utils/ClientUtils.ts';
import { notificationController, uiManagerEvents } from '../../EntryShared.ts';
export const createColorSelectHandler = ({ selectColorAction, isRoomColor, onClose })=>async (colorId)=>{
        const color = editProfileIdMap.fromColorId(colorId);
        AudioManager.play(AudioType.Click);
        await selectColorAction(color);
        if (!isRoomColor) showColorChangedNotification(color);
        onClose();
    };
export const goToStoreColors = ()=>uiManagerEvents.performRoomLeavingAction(()=>navigateToPage('/store#colors', true, true));
const showColorChangedNotification = (color)=>{
    const colorKey = `strings:colonistCommon.playerColors.${EnumUtils.getEnumKey(color, PlayerColor)}`;
    const colorChanged = getNestedTranslation({
        key: 'strings:homePage.header.defaultColorSelector.colorChanged'
    }, {
        color: {
            key: colorKey
        }
    });
    const settlementImage = UIImagePathController.getPlayerColorBuildings(color).settlement;
    notificationController === null || notificationController === void 0 ? void 0 : notificationController.showNotification(settlementImage, colorChanged);
};
